const routes = [
  {
    path: '/my-courses',
    name: 'MyCourseList',
    component: () => import('./pages/CourseList.vue'),
    meta: {
      title: 'Мои курсы',
      authorize: [],
    },
  },
  {
    path: '/author-courses',
    name: 'AuthorCourseList',
    component: () => import('./pages/CourseListAuthor.vue'),
    meta: {
      title: 'Мои курсы',
      authorize: [],
    },
  },
  {
    path: '/teacher-courses',
    name: 'TeachersCourseList',
    component: () => import('./pages/CourseListTeacher.vue'),
    meta: {
      title: 'Мои курсы',
      authorize: [],
    },
  },
  {
    path: '/create',
    name: 'CourseCreate',
    component: () => import('./pages/Create.vue'),
    meta: {
      title: 'Создать курс',
    },
  },
  {
    path: '/:id/gpt-settings',
    name: 'CourseGPTSettings',
    component: () => import('./pages/GPTSettingsPage.vue'),
    meta: {
      title: 'Настройки нейросети',
      type: 'course',
      breadcrumbs: {
        parent: 'CourseUnits',
      },
    },
  },
  {
    path: '/:id/faq-settings',
    name: 'TypicalQuestions',
    component: () => import('./pages/TypicalQuestions.vue'),
    meta: {
      title: 'Типовые вопросы',
      type: 'course',
      breadcrumbs: {
        parent: 'CourseUnits',
      },
    },
  },
  {
    path: '/:id/settings',
    name: 'CourseSettings',
    component: () => import('./pages/Settings.vue'),
    meta: {
      title: 'Настройка курса',
      breadcrumbs: {
        parent: 'MyCourseList',
      },
    },
  },
  {
    path: '/:id/course-units',
    name: 'CourseUnits',
    component: () => import('./pages/Units.vue'),
    meta: {
      title: 'Структура курса',
      authorize: [],
      breadcrumbs: {
        parent: 'MyCourseList',
      },
    },
  },
  {
    name: 'CourseUnitEdit',
    path: '/course-unit/:unitId',
    component: () => import('./pages/UnitEdit.vue'),
    meta: {
      title: 'Редактирование темы',
      authorize: [],
      breadcrumbs: {
        parent: 'CourseUnits',
      },
    },
  },
  {
    path: 'base-knowledge',
    name: 'GptBaseKnowledgeOrg',
    component: () => import('../Education/Teach/pages/Escort/GptBaseKnowledge.vue'),
    meta: {
      title: 'База знаний',
      breadcrumbs: {
        parent: 'MyCourseList',
      },
    },
  },
  {
    path: '/:id/enrollment',
    name: 'CourseEnrollment',
    component: () => import('./pages/CourseEnrollmentList/CourseEnrollmentList.vue'),
    meta: {
      title: 'Наборы на курс',
      authorize: [],
      breadcrumbs: {
        parent: 'MyCourseList',
      },
    },
    children: [
      {
        path: ':enrollmentId/groups/',
        name: 'CourseGroupList',
        component: () => import('./pages/CourseGroups.vue'),
        meta: {
          title: 'Группы набора',
          authorize: [],
          breadcrumbs: {
            parent: 'CourseEnrollment',
          },
        },
        children: [
          {
            name: 'GroupView',
            path: ':groupId',
            component: () => import('../Groups/pages/GroupView/index.vue'),
            meta: {
              title: 'Просмотр группы',
              authorize: [],
              breadcrumbs: {
                parent: 'CourseGroupList',
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:id/constructor',
    name: 'CourseManagementConstructor',
    component: () => import('./pages/Constructor.vue'),
    meta: {
      title: 'Конструктор',
      authorize: [],
      layout: 'empty-layout',
    },
  },
  {
    path: '/:id/enrollment/:enrollmentId',
    name: 'CourseEnrollmentView',
    component: () => import('./pages/Enrollment/Enrollment.vue'),
    children: [
      {
        path: 'settings',
        name: 'CourseEnrollmentSettings',
        component: () => import('./pages/Enrollment/EnrollmentPages/Configuration.vue'),
        meta: {
          title: 'Настройки',
          breadcrumbs: {
            parent: 'CourseEnrollmentView',
          },
        },
      },
      {
        path: 'records',
        name: 'CourseEnrollmentRecords',
        component: () => import('./pages/Enrollment/EnrollmentPages/Records.vue'),
        meta: {
          title: 'Зачисление',
          breadcrumbs: {
            parent: 'CourseEnrollmentView',
          },
        },
      },
      {
        path: 'attestation',
        name: 'CourseEnrollmentAttestation',
        component: () => import('./pages/Enrollment/EnrollmentPages/Attestation.vue'),
        meta: {
          title: 'Аттестация',
          breadcrumbs: {
            parent: 'CourseEnrollmentView',
          },
        },
      },
    ],
    meta: {
      title: 'Набор',
      authorize: [],
      breadcrumbs: {
        parent: 'CourseEnrollment',
      },
    },
  },
  {
    path: '/:enrollmentId/group-create',
    name: 'GroupCreate',
    component: () => import('./pages/GroupCreate.vue'),
    meta: {
      title: 'Создать группу',
      authorize: [],
      breadcrumbs: {
        parent: 'CourseList',
      },
      help: 57,
    },
  },
  {
    path: '/:enrollmentId/group-edit/:groupId',
    name: 'GroupEdit',
    component: () => import('./pages/GroupCreate.vue'),
    meta: {
      title: 'Редактирование группы',
      authorize: [],
      breadcrumbs: {
        parent: 'CourseList',
      },
      help: 57,
    },
  },
  {
    name: 'LessonCreate',
    path: '/:id/course-units/:unitId/create-lesson/',
    component: () => import('./pages/LessonCreate/index.vue'),
    meta: {
      title: 'Добавить уроки',
      authorize: [],
      update: false,
      breadcrumbs: {
        parent: 'CourseUnits',
      },
      help: 56,
    },
  },
  {
    name: 'LessonUpdate',
    path: '/:id/course-units/:unitId/update-lesson/:lessonId',
    component: () => import('./pages/LessonCreate/index.vue'),
    meta: {
      title: 'Обновить урок',
      authorize: [],
      update: true,
      breadcrumbs: {
        parent: 'CourseUnits',
      },
    },
  },
  {
    name: 'CourseRegistrationStaff',
    path: '/course-registration/:courseId/record/:enrollmentId',
    component: () => import('./pages/CourseRegistrationStaff.vue'),
    meta: {
      title: 'Запись сотрудников на курс',
      update: true,
      breadcrumbs: {
        parent: 'CourseList',
      },
    },
  },
  {
    name: 'EnrollmentCreate',
    path: '/:id/enrollment-create',
    component: () => import('./pages/Enrollment/EnrollmentCreate.vue'),
    meta: {
      title: 'Создание набора на курс',
      breadcrumbs: {
        parent: 'CourseEnrollment',
      },
    },
  },
];

export default routes;
